import { render } from "./Forbidden.vue?vue&type=template&id=0598be97&scoped=true&ts=true"
import script from "./Forbidden.vue?vue&type=script&lang=ts"
export * from "./Forbidden.vue?vue&type=script&lang=ts"

import "./Forbidden.vue?vue&type=style&index=0&id=0598be97&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0598be97"]])

export default __exports__